import { patch, get } from 'helpers/api';

export function pinListing({ id, updatePath }) {
  return patch(updatePath, {
    pluginsPluginSet: {
      pinnedListingsAttributes: [
        { propertyPluginListingId: id }
      ]
    }
  });
}

export function unpinListing({ id, updatePath }) {
  return patch(updatePath, {
    pluginsPluginSet: {
      pinnedListingsAttributes: {
        [id]: { _destroy: true, id }
      }
    }
  });
}

export function unpinListings({ ids, updatePath }) {
  const pinnedListingsAttributes = ids.map(id => ({ _destroy: true, id }));
  return patch(updatePath, { pluginsPluginSet: { pinnedListingsAttributes } });
}

export function searchListings({ searchText, searchPath }) {
  const params = searchText.length > 0 ? { searchText } : {};
  return get(searchPath, { params });
}

export function reorderListings({ pinnedListings, updatePath }) {
  const pinnedListingsAttributes = pinnedListings.map((pl, idx) => ({ id: pl.id, sortOrder: idx }));
  return patch(updatePath, { pluginsPluginSet: { pinnedListingsAttributes } });
}
